import React from 'react';

const FULL = 24;
const COMPACT = 12;

/** Pixels lighting up in a grid. Shown the moment an image or video generation starts. */
export default function PixelAssemble({ label, compact }: { label: string; compact?: boolean }) {
  const count = compact ? COMPACT : FULL;
  return (
    <div className={`tb-pixel${compact ? ' is-compact' : ''}`} role="status" aria-live="polite">
      <span className="tb-pixel-grid" aria-hidden="true">
        {Array.from({ length: count }, (_, i) => (
          <i key={i} style={{ animationDelay: `${(i * 0.07) % 0.84}s` }} />
        ))}
      </span>
      <span className="tb-pixel-label">{label}</span>
    </div>
  );
}
